export const spaceName = 'odCoupon';

export interface CouponSettings {
  editingId: number;
  selectedTab: 'information' | 'restriction' | 'limits';
  selectedTranslatedLang: string;
  actionType: 'submit' | false;
  originalData: {
    originalInformation: any;
    originalRestriction: any;
    originalLimits: any;
  };
  currentData: {
    currentInformation: any;
    currentRestriction: any;
    currentLimits: any;
  };
  showMaxSpend: boolean;
  showMinSpend: boolean;
}

export default {
  actionType: false,
  selectedTab: 'information',
  selectedTranslatedLang: 'en_AU',
} as CouponSettings;
